import { ReactNode, useState } from 'react';
import { Menu, X } from 'lucide-react';

interface MobileSidebarWrapperProps {
  children: ReactNode;
}

function MobileSidebarWrapper({ children }: MobileSidebarWrapperProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="lg:hidden fixed top-6 left-6 z-50 w-12 h-12 flex items-center justify-center bg-black/60 border border-violet-500/30 rounded-xl backdrop-blur-xl shadow-[0_24px_60px_rgba(80,50,150,0.35)] hover:border-violet-400/50 transition-all duration-150"
      >
        <Menu className="w-6 h-6 text-violet-200" />
      </button>

      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <>
          <div
            className="lg:hidden fixed inset-0 bg-black/70 backdrop-blur-sm z-50"
            onClick={() => setIsOpen(false)}
          />
          <div className="lg:hidden fixed inset-y-0 left-0 w-80 max-w-[85vw] z-50 p-6 animate-in slide-in-from-left duration-300">
            <div className="relative h-full flex flex-col">
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="absolute -right-4 top-0 w-10 h-10 flex items-center justify-center bg-black/60 border border-violet-500/30 rounded-xl backdrop-blur-xl hover:border-violet-400/50 transition-all duration-150 z-10"
              >
                <X className="w-5 h-5 text-violet-200" />
              </button>
              
              {/* Sidebar Content - Scrollable */}
              <div 
                onClick={() => setIsOpen(false)}
                className="flex-1 overflow-y-auto pr-2 -mr-2"
              >
                {children}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default MobileSidebarWrapper;




